import type { AxiosRequestConfig } from 'axios';
/**
 * Wraps an error that has been canceled due to an AbortController
 */

export default class ApiCanceledError extends Error {
  public name = 'ApiCanceledError';

  // For reporting
  public method: AxiosRequestConfig['method'];
  public uri: string;

  constructor({ method, uri }: { method: AxiosRequestConfig['method']; uri: string }) {
    // See https://www.typescriptlang.org/docs/handbook/release-notes/typescript-2-2.html#support-for-newtarget
    super(`${method} ${uri}`);
    Object.setPrototypeOf(this, new.target.prototype);

    this.message = [method, uri].filter(Boolean).join(' ');
    this.method = method;
    this.uri = uri;
  }
}
